import * as React from "react";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";

export const DashboardNavbar = (props: any) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <Navbar className="journey-header" expand="md">
            <div className="journey-header-background">
            <NavbarBrand>
                <a className="header-logo-link" id="goToDashboardHomePage" href="/dashboard" target="_blank">
                    <img className="logo" src={`/${resourcesHelper.THEME_PATH}/img/brand-logo.svg`} alt={`${resourcesHelper.THEME_PATH} logo icon`} tabIndex={0}/>
                </a>
            </NavbarBrand>
            <NavbarToggler onClick={toggle}/>
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto flex-column-reverse flex-md-row pt-3 pt-md-0" navbar>
                    <NavItem>
                        <span id="logout" role="link" tabIndex={0} onClick={props.logout} onKeyDown={props.logout}
                              aria-label="Log out">Log out</span>
                        <span className="arrow-right"/>
                    </NavItem>
                </Nav>
            </Collapse>
            </div>
        </Navbar>
    );
};
